import React from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import ParkingBookingForm from './ParkingBookingForm';

const HorizontalModule = () => {
    return (
        <React.Fragment>
            <div className="component__parking-horizontal">
                <h3>Airport Parking</h3>
                <ParkingBookingForm />
            </div>
        </React.Fragment>
    );
};

export default HorizontalModule;
